export type ValidStorageTypes = 'sessionStorage' | 'localStorage';
export enum StorageTypes {
  sessionStorage = 'sessionStorage',
  localStorage = 'localStorage'
}

export const assignDefined = <T>(target: T | any, ...sources: T | any) => {
  for (const source of sources) {
    if(!source) continue;
    for (const key of Object.keys(source)) {
      const val = source[key];
      if (val !== undefined && val !== '') {
        target[key] = val;
      }
    }
  }
  return target;
};
